/*global define, console, window, HTMLImageElement, Promise*/
(window.MyModule = function ($, Behaviors) {
    "use strict";
    var module = {};
    function ResourcesModule(elem) {
        Behaviors.init(ResourcesModule, this, arguments);
        var $thisElem = this.$elem;
    }
    Behaviors.inherit(ResourcesModule, Behaviors.Behavior);
    ResourcesModule.QUERY = "[data-ResourcesModule]";
    ResourcesModule.ELEMENTS = {
        loadMoreButton: ".AwardTabs-content_tabs_items_item_loadMore__button",
    };
    Behaviors.register_behavior(ResourcesModule);
    module.ResourcesModule = ResourcesModule;
    return module;
}(window.jQuery, window.Behaviors));
